
import {
    GridFooter,
    GridFooterContainer,
} from "@mui/x-data-grid";
import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";



function CustomFooter() {
    return (

        <GridFooterContainer>
            <Box flexGrow={9}>
            </Box>

            <Box sx={{ flexGrow: 1 }}>
                <Typography
                    variant="h7"
                    noWrap
                    component="div"
                    position={"center"}
                    sx={{ display: { xs: "none", sm: "block" } }}
                >
                </Typography>
            </Box>
            <Box flexGrow={6}>
                <GridFooter/>

            </Box>
        </GridFooterContainer>
    );
}


export default CustomFooter